@if (show) {
  <div class="dating-loader-overlay">
    <div class="dating-loader">
      @for (bar of bars; track bar; let i = $index) {
        <div class="dating-loader__bar"
        [style.animation-delay]="i * 0.1 + 's'"></div>
      }
    </div>
    <p class="dating-loader__text">{{message}}</p>
  </div>
}
